import React from 'react';

export default function BrandMark({ size = "md", className = "", variant = "default" }) {
  const sizes = {
    xs: "w-5 h-5",
    sm: "w-6 h-6",
    md: "w-10 h-10",
    lg: "w-16 h-16",
    xl: "w-24 h-24"
  };

  return (
    <div className={`${sizes[size]} ${className} relative flex items-center justify-center`}>
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        {/* Architectural Structure (Blueprint Blue) */}
        <path 
          d="M15 85V35L50 15L85 35V85" 
          stroke={variant === 'rust' ? '#C1440E' : 'currentColor'} 
          strokeWidth="6" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
        />
        <path 
          d="M32 85V45H68V85" 
          stroke={variant === 'rust' ? '#C1440E' : 'currentColor'} 
          strokeWidth="4" 
          strokeLinecap="round" 
        />
        
        {/* The Vital Pulse (Brick Rust) - Animated */}
        <path 
          d="M5 65H25L35 45L45 85L55 55L65 75H95" 
          stroke="#C1440E" 
          strokeWidth="5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          className="animate-pulse"
        />
        
        {/* Technical Detail Windows */}
        <rect x="35" y="30" width="8" height="8" fill="currentColor" opacity="0.2" />
        <rect x="57" y="30" width="8" height="8" fill="currentColor" opacity="0.2" />
      </svg>
    </div>
  );
}